import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { LocalDataSource } from 'ng2-smart-table';
import { tiens_phieuchi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-ketoan-loccamketchi',
  templateUrl: './loccamketchi.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./loccamketchi.component.scss'],
    providers: [ListService, Repository]
})


export class loccamketchiComponent implements OnInit {

   
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;   

  public tTuNgay: string;
  public tDenNgay: string;
  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();

  indLoading: boolean = false;
  
  source: LocalDataSource;
  inputcamketchis: any = [];
  inputnguons: any = [{ text: 'Kinh phí tự chủ', value: 1 }, { text: 'Kinh phí không tự chủ', value: 0 }]
   
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor(  private repo: Repository) {
    }

  ngOnInit(): void {
    this.source = new LocalDataSource();
    }

  settings = {
    mode: 'external',
    selectMode: 'multi',
    attr: {
      class: 'table table-striped table-bordered table-hover'
    },
    pager:{
      perPage: 1,
      display: false,
    },
    actions: {
    
      add: false,
      edit: false,
      delete: false,

      position: 'right',
    },
    columns: {     
      CTMT: {
        name: 'CTMT',
        width: '200px',
        title: 'CTMT',
      },
     
      Nguon: {
        name: 'Nguon',
        width: '200px',
        title: 'Nguồn',
      },
      Loai_Khoan: {
        name: 'Loai_Khoan',
        width: '200px',
        title: 'Loại khoản',
      },
      Tieu_Muc: {
        name: 'Tieu_Muc',
        width: '200px',
        title: 'Tiểu mục',
      },
      So_Duoc_Giao_Du_Toan: {
        name: 'So_Duoc_Giao_Du_Toan',
        title: 'Số tiền',
        width: '100px',
        type: 'custom',
        renderComponent: NumberViewComponent,
      },
     
    },
  };
  khoangthoigian: number = 20;

  donviid: any;
  username: any;
  namketoan: any
  phanheid: any;
  nguonkinhphi: string;

  loadDataInit(tdonviid: any, tusername: any, tnamketoan: any)
  {
    
    this.repo.postRequest('api/chungtu/get_camketchi', { Chuoi: tdonviid })
      .subscribe(response => {
        this.inputcamketchis = response;
        this.cam_ket_chi_id = null;
        this.source.load([]);
      });


    
  }

  onDoiTuongChange($event)
  {
    if (typeof $event === "undefined") {
      this.selectedRows = [];
      this.source.load([]);
    }
    else {

      this.repo.postRequest("api/chungtu/get_camketchi_chitiet/", { Chuoi: $event.Id })
        .subscribe(response => {
          console.log(response);
          this.source.load(response);
        });
    }
    
  }


  

    keyTenPress(event: any) { 
      
  }
  selectedRows: any;
  cam_ket_chi_id: any;
  onRowSelect(event) {
    this.selectedRows = event.selected;
  }
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    console.log(this.selectedRows);
    if (typeof this.selectedRows === "undefined" || this.selectedRows === null) {
      swal('Cảnh báo!', "Bạn chưa chọn chi tiết cam kết chi", 'warning');
      return;
    }
    else
      this.save.emit({ ckc: this.cam_ket_chi_id, data:this.selectedRows});
    }
   
    
   

   


}
